<template>
    <div :class="`customer-${customerIdent}`">
        <GuestRootView v-if="!authenticated" />
        <AuthRootView v-if="authenticated" />
    </div>
</template>

<script>
import AuthRootView from '@/views/auth/AuthRootView.vue';
import GuestRootView from '@/views/guest/GuestRootView.vue';
import { customer } from '@/helpers/globals';

export default {
    name: 'App',
    components: {
        AuthRootView,
        GuestRootView,
    },

    data: () => ({
        customerIdent: customer(),
    }),

    computed: {
        authenticated() {
            return this.$store.getters.isAuthenticated;
        },
    },
};
</script>
